import {
  backgroundMapper,
  getRichTextMultilocale,
} from '@quno/onboarding/src/generator/configs/componentMapper';
import { useEffect, useState } from 'react';
import {
  defaultLocale,
  localeToLanguageCodeMapper,
} from '@quno/onboarding/src/constants/locales';
import { localeMapper } from '@quno/patient-journey/src/constants/locales';
import { useTranslation } from '@quno/patient-journey/src/hooks/useTranslation';
import { HeroFunnel } from '@quno/patient-journey/src/components/Hero/HeroFunnel';
import type { CtaProps } from '@quno/patient-journey/src/components/Cta/Cta';
import type { FormLocales } from '@quno/patient-journey/src/constants/locales';
import type { Document } from '@contentful/rich-text-types';
import type { HeroAndFunnel as HeroAndFunnelProps } from '@quno/onboarding/src/generator/types/Models';

export const HeroAndFunnel = (
  props: HeroAndFunnelProps & { locale: FormLocales; isPreview?: boolean },
): JSX.Element => {
  const { locale: pageLocale } = useTranslation();
  const locale = props.locale || localeMapper[pageLocale] || defaultLocale;
  const [textContent, setTextContent] = useState<Document | undefined>();
  const { attributes, isPreview } = props ?? {};
  const { text } = attributes ?? {};

  const funnel = attributes?.funnel?.[defaultLocale] || '';
  const funnelPosition = attributes?.funnelPosition?.[defaultLocale];
  const background = backgroundMapper(attributes.background);
  const fontColor = attributes?.fontColor?.[defaultLocale] || 'black';
  const cta = {
    ...attributes?.cta?.[defaultLocale],
    locale,
  } as CtaProps;

  useEffect(() => {
    const run = async (): Promise<void> => {
      const content = await getRichTextMultilocale(text, locale);
      setTextContent(content);
    };

    void run();
  }, [text, locale]);

  return (
    <HeroFunnel
      funnelId={funnel}
      text={textContent}
      fontColorOverride={fontColor}
      ctas={cta ? [cta] : []}
      image={background?.image}
      isPreview={isPreview}
      locale={localeToLanguageCodeMapper[locale]}
      flipContent={funnelPosition === 'left' ? true : false}
      {...background}
    />
  );
};
